<script lang="ts" setup>
import { ChatBubbleLeftIcon, PhotoIcon } from '@heroicons/vue/24/outline';
import { Badge } from '@vue-interface/badge';
import { computed } from 'vue';
import { pbtMessageType } from '../composables/pbtMessageType';

const props = withDefaults(defineProps<{
    channelType: string | null | undefined;
    size?: 'sm'|'md'|'lg';
}>(), {
    size: 'md',
});

const type = computed(() => pbtMessageType(props.channelType));
</script>

<template>
    <Badge
        :size="{
            'badge-xs': size === 'sm',
            'badge-md': size === 'md',
            'badge-lg': size === 'lg',
        }"
        :class="type.name === 'MMS' ? 'badge-blue-600' : 'badge-emerald-600'">
        <div
            class="gap-1 inline-flex items-center"
            :title="type.description"
            :data-message-type="type.name">
            <PhotoIcon
                v-if="type.name === 'MMS'"
                :class="{ 'w-3 h-3': size === 'sm', 'w-4 h-4': size === 'md', 'w-5 h-5': size === 'lg' }" />
            <ChatBubbleLeftIcon
                v-else
                :class="{ 'w-3 h-3': size === 'sm', 'w-4 h-4': size === 'md', 'w-5 h-5': size === 'lg' }" />
            {{ type.name }}
        </div>
    </Badge>
</template>
